import styled from "styled-components";
import { Link } from "react-scroll";

export const HeroSection = styled.section`
  position: relative;
  min-height: 100vh;
  width: 100%;
  overflow: hidden;

  @media (max-width: 1050px) {
    min-height: 0;
    padding-top: 50vh;
  }

  @media (orientation: landscape) and (max-width: 1050px) {
    padding-top: 100svh;
  }
`;

export const HeroImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;

  @media (max-width: 1050px) {
    inset: 0 0 auto 0;
    height: 50vh;
  }

  @media (orientation: landscape) and (max-width: 1050px) {
    height: 100svh;
  }
`;

export const HeroOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ $hasBottomContent }) =>
    $hasBottomContent ? "20px 20px 180px" : "0 20px"};
  background: rgba(0, 0, 0, 0.2);

  @media (max-width: 1050px) {
    inset: 0 0 auto 0;
    height: 50vh;
    padding: 0 20px;
  }

  @media (orientation: landscape) and (max-width: 1050px) {
    height: 100svh;
  }
`;

export const HeroWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 20px;
`;

export const Header = styled.h1`
  margin: 0;
  color: white;
  font-size: clamp(1.8rem,6vw,10rem);
  font-weight: 600;
  line-height: 1;
  letter-spacing: -0.03em;
  max-width: 22ch;
`;

export const SubHeader = styled.h2`
  margin: 0;
  color: white;
  font-size: clamp(1.1rem,3vw,3rem);
  font-weight: 400;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
  width: 350px;

        @media (max-width: 768px) {
          width: 230px;
          gap: 10px;

    }
`;

export const Button = styled(Link)`
  flex: 1;
  color: white;
  text-decoration: none;
  padding: 12px 24px;
  font-size: 20px;
  font-weight: 400;
  border: 2px solid white;
  border-radius: 10px;
  cursor: pointer;
  margin: 0;
  transition: background-color 0.3s, border-color 0.3s;
  background-color: transparent;

    &:hover {
        background-color: hsla(93, 19%, 58%, 1.00);
        border-color: hsla(93, 19%, 58%, 1.00);
    }

      @media (max-width: 768px) {
        font-size: 16px;
        padding: 10px 20px;
    }
`;

export const HeroBottomContent = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 100%;

  @media (max-width: 1050px) {
    position: relative;
    left: auto;
    bottom: auto;
  }
`;